<template>
  <section
    v-editable="blok"
    :class="sectionClass"
    class="block block-tool-get-help"
  >
    <component
      :is="tab.tab_component[0].component"
      v-for="(tab, index) in tabs"
      v-show="currentTab === index"
      :key="index"
      :blok="tab.tab_component[0]"
      :cta="tab.tab_cta"
    >
      <h2 v-if="title" class="h1">
        {{ title }}
      </h2>
      <div class="tabs flex">
        <div
          v-for="(tabItem, tabIndex) in tabs"
          :key="tabItem._uid"
          :class="{ active: currentTab === tabIndex }"
          class="button button--xl tab"
          @click="toggleTab(tabIndex)"
        >
          <span>
            {{ tabItem.tab_label }}
          </span>
        </div>
      </div>
    </component>
  </section>
</template>

<script setup lang="ts">
import type { BlockToolGetHelpStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockToolGetHelpStoryblok
}>()
const { sectionClass, title } = useStoryContent(toRefs(props))
const currentTab = ref(0)
const tabs = computed(() => props.blok.tab)
function toggleTab(index: number) {
  currentTab.value = index
}
</script>

<style lang="less">
section.block-tool-get-help {
  .container {
    .card {
      .card__inner {
        .card__content {
          h2 {
            .text-center();

            @media @tablet {
              .text-left();
            }
          }
        }
      }
    }
  }

  .tabs {
    justify-content: center;
    margin: @gutter-sm -@gutter @gutter-lg;

    @media @tablet {
      margin: 0 0 @gutter;
    }

    &::after {
      .hidden();

      content: '';
      width: 100%;
      border-bottom: solid @3px @color-border;

      @media @tablet {
        .block();
      }
    }

    .tab {
      .justify-center();
      .flex-no-shrink();

      border: none;
      flex-basis: 50%;
      overflow: hidden;
      margin-right: @1px;
      white-space: nowrap;
      padding: @gutter @gutter-lg;
      color: @color-fill-text-alt;
      border-top: solid @3px @color-border;
      background-color: @color-fill-alternate;

      @media @tablet {
        .justify-start();

        flex-basis: auto;
        background: none;
        border-top: none;
        border-bottom: solid @4px @color-border;
      }
      span {
        .font-body();
        .font-medium();
        .overflow-text();
        .font-size(16, 21);

        @media @tablet {
          .font-black();
          .font-base();
        }
      }

      &.active {
        color: @color-text;
        background: none;
        border-color: @state-success;
      }

      &:first-child.active {
        border-color: @color-primary;
      }
    }
  }

  h2.h2 {
    .hidden();
  }
}
</style>
